import { FileText, ArrowSquareOut } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';
import { docLink } from './devApi';

const CONF = {
  high: { label: '根拠あり', cls: 'border-emerald-300 bg-emerald-100 text-emerald-800' },
  medium: { label: '要確認', cls: 'border-amber-300 bg-amber-100 text-amber-800' },
  low: { label: '推測を含む', cls: 'border-zinc-300 bg-zinc-100 text-zinc-700' },
};

export const ConfidenceBadge = ({ level, testid }) => {
  const c = CONF[level] || CONF.low;
  return (
    <span data-testid={testid}
      className={`inline-flex items-center rounded border px-1.5 py-0.5 text-[11px] font-semibold ${c.cls}`}>
      {c.label}
    </span>
  );
};

/** 出典（Source Citations）— クリックでドキュメントアプリの該当ページを開く。 */
export const CitationList = ({ citations, testid }) => {
  if (!citations || citations.length === 0) {
    return (
      <p className="mt-1.5 text-[11px] text-zinc-500" data-testid={testid}>
        出典: メモのみ（書類の根拠なし）
      </p>
    );
  }
  return (
    <div className="mt-1.5 space-y-1" data-testid={testid}>
      <p className="text-[11px] font-semibold text-zinc-600">出典（クリックで書類を開きます）:</p>
      {citations.map((c, i) => (
        <Link key={`${c.document_id}-${c.page}-${i}`} to={docLink(c.document_id, c.page)}
          title="ドキュメントアプリで該当ページを開く"
          className="block rounded border border-zinc-200 bg-zinc-50 px-2 py-1 transition-colors hover:border-teal-400 hover:bg-teal-50/70"
          data-testid={`${testid}-item-${i}`}>
          <p className="flex items-center gap-1 text-[11px] font-medium text-zinc-800">
            <FileText size={11} className="shrink-0 text-teal-700" />
            <span className="truncate">
              {c.document_number ? `${c.document_number} · ` : ''}{c.title}
            </span>
            <span className="ml-auto flex shrink-0 items-center gap-1 text-zinc-600">
              p.{c.page} <ArrowSquareOut size={11} />
            </span>
          </p>
          {c.snippet && (
            <p className="mt-0.5 line-clamp-2 text-[11px] leading-4 text-zinc-500">
              「{c.snippet}…」
            </p>
          )}
        </Link>
      ))}
    </div>
  );
};

/** 証跡（写真・試験報告書など）の小さなチップ列。クリックで該当ページを開く。 */
export const EvidenceChips = ({ evidence, testid }) => {
  if (!evidence || evidence.length === 0) {
    return <span className="text-xs text-zinc-500" data-testid={testid}>証跡なし</span>;
  }
  return (
    <span className="flex flex-wrap gap-1.5" data-testid={testid}>
      {evidence.map((e, i) => (
        <Link key={`${e.document_id}-${i}`} to={docLink(e.document_id, e.page)}
          data-testid={`${testid}-item-${i}`}
          className="inline-flex items-center gap-1 rounded-md border border-zinc-300 bg-white px-2 py-0.5 text-xs text-zinc-800 hover:border-teal-400 hover:bg-teal-50/70">
          <FileText size={11} className="text-teal-700" />
          {e.title || e.document_number || '書類'}{e.page ? ` p.${e.page}` : ''}
          <ArrowSquareOut size={10} />
        </Link>
      ))}
    </span>
  );
};
